<template>
  <div class="stepper">
    <div class="stepper-header">
      <!-- 1 -->
      <div class="stepper-step" :class="{ active: currentStep == 1 }">
        <div class="stepper-icon">1</div>
        <div class="stepper-text">上傳CSV或XLS</div>
      </div>
      <!-- divider -->
      <div class="page-divider"></div>
      <!-- 2 -->
      <div class="stepper-step" :class="{ active: currentStep == 2 }">
        <div class="stepper-icon">2</div>
        <div class="stepper-text">上傳ZIP檔(圖片,影片)</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      default: 1,
    },
  },
};
</script>

<style lang="scss">
.stepper {
  &-header {
    display: flex;
    .page-divider {
      align-self: center;
      margin-left: 20px;
      margin-right: 20px;
      flex-grow: 1;
      border-bottom: 1px solid #848fa0;
    }
  }
  &-step {
    display: flex;
    align-items: center;
    &.active {
      .stepper-icon {
        background-color: #1240a8;
      }
      .stepper-text {
        color: #1240a8;
      }
    }
  }
  &-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin-right: 10px;
    color: white;
    background-color: #848fa0;
    border-radius: 50%;
    &.active {
      background-color: #1240a8;
    }
  }
  &-text {
    color: #848fa0;
    &.active {
      color: #1240a8;
    }
  }
}
</style>
